import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';
import type { SecuredComponentBaseProps } from '../../types';
import { useSecurity } from '../hooks/useSecurity';

type SecuredButtonProps = Omit<ButtonProps, 'disabled'> &
    SecuredComponentBaseProps & {
        disabled?: boolean;
    };

export default function SecuredButton({
    securityAction,
    securityTarget,
    securityEnforcementMode = 'hidden',
    fallback = null,
    disabled,
    ...buttonProps
}: SecuredButtonProps) {
    const decision = useSecurity(securityAction, securityTarget);

    if (!decision.allowed && securityEnforcementMode === 'hidden') {
        return fallback;
    }

    const isDisabled = !decision.allowed || decision.pending;

    return <Button {...buttonProps} disabled={isDisabled || Boolean(disabled)} />;
}
